var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-title"},[_c('h3',{on:{"click":_vm.clickChange}},[_vm._v(_vm._s(_vm.row.name))]),(_vm.subCate && _vm.subCate.length)?_c('p',[_c('em',{staticClass:"iconfont icon-arrow-right-filling"}),_vm._l((_vm.subCate),function(item,index){return [(index<12 && item.name!=_vm.row.name)?_c('router-link',{key:index,attrs:{"to":{
          path: _vm.row.path,
          query:{
            cate: _vm.row.id,
            'subId':item.id
          }
        }}},[_c('span',[_vm._v(_vm._s(item.name))])]):_vm._e()]})],2):_vm._e(),_c('div',{staticClass:"more-btn",on:{"click":_vm.clickChange}},[_c('em',[_vm._v("更多")]),_c('span',{staticClass:"iconfont icon-arrow-right"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }